<template>
  <v-app>
    <router-view/>
    <v-snackbar
      v-model="globalSnackbar"
      :color="globalSnackbarColor"
      :timeout="5000"
      :top="true"
      class="text-center justify-center"
    >
      <div class="text-subtitle-2 text-center flex-grow-1">{{ globalSnackbarText }}</div>
    </v-snackbar>
  </v-app>
</template>

<script>
  import localize from '@/filters/localize';

  export default {
    watch: {
      $route (to) {
        document.title = localize(to.meta.title) + ' | Fraktus.se' || 'Fraktus'
      }
    },
    computed: {
      globalSnackbar: {
        get() {
          return this.$store.getters.globalSnackbar;
        },
        set(newValue) {
          this.$store.commit('changeGlobalSnackbar', newValue);
        },
      },
      globalSnackbarColor() {
        return this.$store.getters.globalSnackbarColor;
      },
      globalSnackbarText() {
        return this.$store.getters.globalSnackbarText;
      },
    },
  };
</script>

<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: black;
    background-color: #fafafa;
  }

  .main-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .v-text-field__details {
    padding: 0 !important;

    .v-messages__message {
      line-height: 1.2 !important;
    }
  }

  // PlaceAutocompleteElement (Places API New) is a closed-shadow-DOM web
  // component: its border, focus ring and height live inside the shadow tree with
  // no official CSS hook (only the `input` part is exposed). So we keep its native
  // look and only stretch it to full width, forcing a light color-scheme to match
  // the app. Matching the neighbouring Vuetify fields pixel-for-pixel would require
  // hacking the closed shadow DOM, which we deliberately don't do.
  .google-autocomplete {
    display: block;
    width: 100%;
    color-scheme: light;
  }

  .google-autocomplete::part(input) {
    box-sizing: border-box;
    width: 100%;
  }
</style>
